import { FlexibleCompensationConfigUpdateI } from './interfaces/FlexibleCompensationConfig';

const updateFlexibleCompensationConfig = async (
	token: string,
	config: FlexibleCompensationConfigUpdateI
) => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/companies/flexible-compensation-config`,
		{
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(config)
		}
	);

	return response.json();
};

export default updateFlexibleCompensationConfig;
